import React, { useState, useEffect } from "react";
import "../blocks/Concerts.css";
import ConcertCard from "./ConcertCard";

function Concerts() {
  const [concerts, setConcerts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/concerts")
      .then((res) => res.json())
      .then((data) => {
        setConcerts(data);
      })
      .catch((err) => {
        console.error("Error fetching concerts:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div className="concerts">
      {loading ? (
        <span className="concerts__loading" />
      ) : (
        <div className="concerts__grid">
          {concerts.map((concert) => (
            <ConcertCard key={concert._id} concert={concert} />
          ))}
        </div>
      )}
    </div>
  );
}

export default Concerts;
